import React from 'react';

import { Stack } from 'common/components/material';

import { ObjectiveFilterOption } from '../hooks/useObjectiveFilters';
import ObjectiveFilterPill from './objective-filter-pill.component';

type ObjectiveFilterPillRowProps = {
  options: ObjectiveFilterOption[];
  selectedKeys: string[];
  onToggle: (key: string) => void;
};

const ObjectiveFilterPillRow: React.FC<ObjectiveFilterPillRowProps> = ({
  options,
  selectedKeys,
  onToggle,
}) => (
  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
    {options.map((option) => (
      <ObjectiveFilterPill
        key={option.key}
        label={option.label}
        count={option.count}
        active={selectedKeys.includes(option.key)}
        onClick={() => onToggle(option.key)}
      />
    ))}
  </Stack>
);

export default ObjectiveFilterPillRow;
